// src/pages/returnNote/ReturnNoteA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { formatCurrency } from '../../utils/orderCalculations';
import { getImageUrl } from '../../utils/imageUtils';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';

const ReturnNoteA4Document = ({ returnNote }) => {
  const { t } = useLocalization();

  if (!returnNote) return null;

  return (
    <A4DocumentLayout
      title={t('returnNote.returnNoteNumber')}
      logoUrl={getImageUrl(returnNote.originalOrder?.Shop?.logo)}
      subtitle={t('returnNote.officialReturnNote', 'Official Return Note')}
      documentNumber={`#${returnNote.returnNumber}`}
      metaRows={[
        { label: t('common.created'), value: new Date(returnNote.createdAt).toLocaleString() },
        { label: t('common.status'), value: (returnNote.status || '').toUpperCase() },
      ]}
      infoCards={[
        {
          title: t('returnNote.originalOrder'),
          primary: `#${returnNote.originalOrder?.orderNumber || t('common.na')}`,
          lines: [`${t('returnNote.refundMethod')}: ${t(`returnNote.refundMethod_${returnNote.refundMethod}`)}`],
        },
        {
          title: t('returnNote.cashier'),
          lines: [
            returnNote.cashier?.name || t('common.na'),
            parseFloat(returnNote.loyaltyPointsDeducted) > 0 && `${t('returnNote.loyaltyPointsDeducted')}: ${returnNote.loyaltyPointsDeducted}`,
          ].filter(Boolean),
        },
      ]}
      items={{
        columns: [
          { header: '#', align: 'center', width: '40px' },
          { header: t('returnNote.item') },
          { header: t('returnNote.returnQty'), align: 'center' },
          { header: t('returnNote.refundAmount'), align: 'right' },
        ],
        rows: (returnNote.returnItems || []).map((item, index) => [
          index + 1,
          <>
            <strong>{item.Product?.name || t('common.na')}</strong>
            {item.ProductVariation?.sku && <span style={{ opacity: 0.7, fontSize: '0.8em' }}> — SKU: {item.ProductVariation.sku}</span>}
          </>,
          item.quantityReturned,
          <strong>{formatCurrency(item.refundAmount)}</strong>,
        ]),
      }}
      summary={{
        notes: { label: t('returnNote.reason'), text: returnNote.reason || t('common.none', 'None') },
        totals: [{ label: t('returnNote.totalRefundAmount'), value: formatCurrency(returnNote.totalRefundAmount), variant: 'grand' }],
      }}
      footerNote="This is a computer-generated return note."
    />
  );
};

export default ReturnNoteA4Document;
